import classNames from 'classnames/bind';
import React from 'react';
import styles from 'componets/button/index.module.scss';
import LoadingIcon from 'componets/button/loading-icon';

const cx = classNames.bind(styles);

const Button = ({
  type,
  style = undefined,
  className = '',
  loading = false,
  onClick,
  variant = 'default',
  theme = 'blue',
  children,
  dataCy,
  leftIcon,
  rightIcon,
  disabled,
}) => {
  const btnClass = cx({
    button: true,
    loading: loading,
    [variant]: true,
    [theme]: true,
  });

  return (
    <button
      type={type}
      style={style}
      data-cy={dataCy}
      className={`${btnClass} ${className}`}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      disabled={disabled || loading}
    >
      {loading ? (
        <LoadingIcon />
      ) : (
        <>
          {leftIcon ? <span className={styles['left-icon-container']}>{leftIcon}</span> : null}
          {children}
          {rightIcon ? <span className={styles['right-icon-container']}>{rightIcon}</span> : null}
        </>
      )}
    </button>
  );
};

export default Button;
